const skipToTimeIndex = function (state, value) {
    state.player.$emit('seek', value);
    state.player.$emit('pause');
};

export {
    skipToTimeIndex,
};